// src/awsConfig.js
import { CognitoUserPool } from "amazon-cognito-identity-js";

// Replace these values with your actual User Pool details
const poolData = {
  UserPoolId: "us-east-1_EHLNaw2f5", // Example: 'us-east-1_AbCdEf123'
  ClientId: "2qlo02casnk0gthkjem39uvlfj", // Example: '12345abcde6789fghijklmnop'
};

// Export the configured Cognito User Pool
export const userPool = new CognitoUserPool(poolData);
